import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=e42a835a&scoped=true"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=e42a835a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42a835a",
  null
  
)

export default component.exports